import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import orderBy from 'lodash/orderBy';

import { fetchAlerts } from '../actions/navigation/alertActions';
import getLocationParams from '../helpers/getLocationParams';
import { useSlugLookup } from './useSlugs';
import { assetSelector } from '../selectors/assets';
import { fetchAsset } from '../actions/assets/assetsActions';

export function useFacilityAlerts() {
    const rawAlerts = useSelector((state) => state?.alertsNotification?.alerts) || [];
    const assetState = useSelector(assetSelector);
    const dispatch = useDispatch();
    const location = useLocation();

    const locationParams = getLocationParams(location);
    const {locationId, locationType, loaded: slugLoaded} = useSlugLookup(locationParams?.location_id);
    if(!!locationParams && slugLoaded && locationId) {
        locationParams.location_id = locationId;
        locationParams.location_type = locationType;
    }
    const loaded = slugLoaded && (!locationParams?.isGateway || assetState?.loaded);
    useEffect(() => {
        if(locationParams?.isGateway && slugLoaded){
            dispatch(fetchAsset(locationParams?.location_id));
        }
    }, [locationParams?.location_id, locationParams?.isGateway, slugLoaded]);

    if(locationParams?.isGateway && assetState?.loaded){
        locationParams.location_id = assetState?.data?.internal_location_id;
    }
    /**
     * On mount and location change,
     * Call redux action to fetch alerts
     */
    useEffect(() => {
        if(loaded) {
            dispatch(fetchAlerts(locationParams));
        }
    }, [locationParams?.location_id, locationParams?.location_type, loaded, dispatch]);

    if(!locationParams?.location_id){
        return [];
    }
    const filteredAlerts = rawAlerts.filter(({ canceled_at: canceled, location_display_rules: { display_at_gateway, display_at_pass }}) => {
        return !canceled &&
            (!locationParams.isGateway || display_at_gateway) &&
            (!locationParams.isPass || display_at_pass);
    });
    const sortedAlerts = orderBy(filteredAlerts, ['created_at'], ['desc']);

    return sortedAlerts;
}
